import { onSelectCol } from 'common/Prose/Commands/columns'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { findParentNodeOfType } from 'prosemirror-utils'
import { type EditorView } from 'prosemirror-view'
import * as React from 'react'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'

interface Props {
  view: EditorView
}

export const useColumns = ({ view }: Props) => {
  const [, forceRender] = React.useState<number>(0)
  const editorState = useContext(AlmanacEditorStateContext)
  const $colGroupPos = findParentNodeOfType(view.state.schema.nodes.column_group)(view.state.selection)
  const columnCount = editorState?.columnCount ?? ($colGroupPos ? $colGroupPos.node.content.childCount : 1)
  const turn_into_distribute = useFlipperFlag('turn_into_distribute')

  const _onSelectCol = (n: number) => () => {
    if (!editorState) return
    const {
      selection: { $from, $to },
    } = editorState
    /**
     * We only allow distributing when:
     * - The user has the `turn_into_distribute` flag enabled
     * - They are selecting a root-level textWrap node
     * - The selection does not cross to another node
     */
    const shouldDistribute =
      turn_into_distribute &&
      $from.node().type.groups.includes('textWrap') &&
      $from.sameParent($to) &&
      $from.depth === 1
    onSelectCol(n, shouldDistribute)(view.state, view.dispatch)
    forceRender(Date.now())
    setTimeout(() => {
      // we need to wait for the next tick to focus the editor because `forceRender` will cause the
      // editor to lose focus (for some reason)
      // this is a hack to fix an issue where clicking the columns button would appear to lose the
      // selection, but then when you moved your mouse it would reappear
      view.focus()
    }, 0)
  }

  return { _onSelectCol, columnCount }
}
